import { useMemo } from 'react';

import { IGetGameAssets, TGameAssetsResult } from './types';
import { IGameAsset, IGameCustomFieldData } from '@theme/js/hooks/games/types';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';

export const useGetGameAssets = (
    game: IGetGameAssets,
    translate: ITranslateMethod
): TGameAssetsResult => {
    return <TGameAssetsResult>useMemo(() => {
        const gameCustomFieldsData: IGameCustomFieldData[] = game?.gameCustomFieldsData || [];
        const assets: IGameAsset | undefined = game?.additionalAssets?.[0];

        const findCustomFieldValue = (name: string, tpe: string) =>
            gameCustomFieldsData.find((item: IGameCustomFieldData): boolean =>
                item.name === name && item.tpe === tpe
            )?.value;
        const blockedIcon = findCustomFieldValue('blocked-icon', 'image');
        const blockedText = findCustomFieldValue('blocked-text', 'text');

        const background = assets?.url || blockedIcon
            ? { backgroundImage: `url('${assets?.url || blockedIcon}')` }
            : null;

        const blockedTextValue = assets?.name
            ? translate(`playtech.mobile.system.blocked.${assets.name}`)
            : blockedText && blockedText?.length
                ? translate(blockedText, blockedText)
                : translate('playtech.mobile.system.blocked.default');

        return { background, tKey: blockedTextValue };
    }, [game?.gameCustomFieldsData, game?.additionalAssets, translate]);
};
